import React, { Component } from "react";
import BottomNavigation from "reactjs-bottom-navigation";
import "reactjs-bottom-navigation/dist/index.css";
import { UnorderedListOutlined, CheckCircleOutlined } from "@ant-design/icons";

export default class DriverFooter extends Component {
  onClickMenu = (menu) => {
    window.location.assign(menu);
  };

  render() {
    const bottomNavItems = [
      {
        title: "ToDo",
        icon: (
          <UnorderedListOutlined
            style={{ fontSize: "24px", cursor: "pointer" }}
          />
        ),
        activeIcon: (
          <UnorderedListOutlined
            style={{ fontSize: "24px", color: "#E6EDF4", cursor: "pointer" }}
          />
        ),
        onClick: () => {
          this.onClickMenu("/app/driver/todo");
        },
      },
      {
        title: "Done",
        icon: (
          <CheckCircleOutlined
            style={{ fontSize: "24px", cursor: "pointer" }}
          />
        ),
        activeIcon: (
          <CheckCircleOutlined
            style={{ fontSize: "24px", color: "#E6EDF4", cursor: "pointer" }}
          />
        ),
        onClick: () => {
          this.onClickMenu("/app/driver/done");
        },
      },
    ];

    return (
      <div>
        <BottomNavigation
          items={bottomNavItems}
          defaultSelected={
            window.location.pathname === "/app/driver/todo"
              ? 0
              : window.location.pathname === "/app/driver/done" && 1
          }
          activeBgColor="#0E4D90"
          color="#E6EDF4"
          onItemClick={(item) => console.log(item)}
          style={{ cursor: "pointer" }}
        />
      </div>
    );
  }
}
